<nav>
  <ul class="breadcrumb">
    <li class="ms-auto"><a routerLink="/agency-admin"><i class="fa fa-building" style="width: 20px;"></i>Agency Security Management</a></li>
  </ul>
</nav>
<div class="d-flex justify-content-center align-items-center">
  <h1 class="me-2">Site Security Management</h1>
</div>
@for (error of errors; track error) {
  <div class="col-12 col-lg-6 offset-lg-3">
    <ngb-alert type="danger" (close)="closeError(error)">{{ error }}</ngb-alert>
  </div>
}
@if (applications && applications.length == 0) {
  <div class="alert alert-warning col-12 col-sm-6 offset-sm-3">There are no Site Security Administrators.</div>
}
@if (applications && applications.length > 0) {
  <form [formGroup]="siteAdminForm">
    <div class="row">
      <div class="py-4 col-3 col-sm-2 col-lg-1">
        <label for="application" style="font-weight: bold; font-size: 0.9375em; padding-top: 0.5em">Application:</label>
      </div>
      <div class="py-2 py-sm-4 col-7 col-sm-3 col-lg-2">
        @if (applications && applications.length == 1) {
          <input type="text" id="applicationTextbox" formControlName="applicationTextbox" readonly="readonly" class="form-control" labelForId="application" />
        }
        @if (applications && applications.length > 1) {
          <select id="application" formControlName="application" class="form-select" labelForId="application" (change)="onApplicationChange()">
            @for (application of applications; track application) {
              <option [ngValue]="application.id">{{ application.name }}</option>
            }
          </select>
        }
      </div>
    </div>
    <div class="row">
      <div class="table-caption col-10">Site Security Administrators: @if (siteAdminHelpMessage) {
        <i class="fa fa-question-circle" [ngbTooltip]="siteAdminHelpMessage"></i>
      }</div>
      <div class="text-end col-2"><button (click)="NewSiteAdmin()">New</button></div>
    </div>
    <div class="row">
      <div class="col-12">
        @if (siteAdmins) {
          <table class="table table-striped table-responsive-sm">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email/Username</th>
                <th scope="col">Login Allowed</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              @for (siteAdmin of siteAdmins; track siteAdmin) {
                <tr>
                  <td>{{ siteAdmin.displayName }}</td>
                  <td>{{ siteAdmin.username }}</td>
                  <td>{{ renderAllowLogin(siteAdmin.allowLogin) }}</td>
                  <td></td>
                  <td ngbDropdown>
                    <button ngbDropdownToggle id="adminActions">Actions</button>
                    <div ngbDropdownMenu aria-labelledby="userActions">
                      <button ngbDropdownItem (click)="SiteAdminDetails(siteAdmin.username)"><i class="fa fa-pencil-square-o" style="width: 17px;"></i> Details</button>
                      <button ngbDropdownItem (click)="RemoveSiteAdmin(siteAdmin.id, siteAdmin.username)"><i class="fa fa-times" style="width: 17px;"></i> Remove</button>
                      <button ngbDropdownItem (click)="ResetSiteAdminPassword(siteAdmin.id)"><i class="fa fa-envelope-o" style="width: 17px;"></i> Send Password Reset Email</button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </form>
}
<app-user-detail #adminDetail [isDuplicate]="isAdminDuplicate" [isAlreadyAssigned]="isAdminAlreadyAssigned" [accountAllowLoginHelpMessage]=accountAllowLoginHelpMessage (result)="onAdminUpdate($event)"></app-user-detail>
<app-confirmation #confirmDelete title="Delete Confirmation" (result)="onDeleteConfim($event)"></app-confirmation>
